import { Button, ButtonProps, styled } from '@mui/material';
import React from 'react'

const ButtonStyled = styled(Button)<ButtonProps>(({ theme }) => ({
    backgroundColor: '#226DD4',
    color: 'white',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
    padding: 20,
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#226DD4',
    },
}));

export default ButtonStyled;